import { useEffect, useState } from 'react'

type Options = {
  typingSpeed?: number // скорость набора (мс на символ)
  deletingSpeed?: number // скорость стирания
  pauseTime?: number // пауза перед стиранием/новым словом
  loop?: boolean // повторять или остановиться
}

export function useTypewriter(
  texts: string[],
  { typingSpeed = 120, deletingSpeed = 80, pauseTime = 1000, loop = true }: Options = {}
) {
  const [text, setText] = useState('')
  const [index, setIndex] = useState(0)
  const [isDeleting, setIsDeleting] = useState(false)

  useEffect(() => {
    const current = texts[index % texts.length]
    let timer: NodeJS.Timeout

    if (!loop) return

    if (isDeleting) {
      timer = setTimeout(() => {
        setText((t) => t.slice(0, -1))
        if (text === '') {
          setIsDeleting(false)
          setIndex((i) => (i + 1) % texts.length)
        }
      }, deletingSpeed)
    } else {
      timer = setTimeout(() => {
        setText(current.slice(0, text.length + 1))
        if (text === current) {
          setTimeout(() => setIsDeleting(true), pauseTime)
        }
      }, typingSpeed)
    }

    return () => clearTimeout(timer)
  }, [text, isDeleting, index, texts, typingSpeed, deletingSpeed, pauseTime, loop])

  return text
}
